// extracted by mini-css-extract-plugin
var _1 = "RatingItem-modulehoverItem__IiG7M";
var _2 = "RatingItem-moduleicon__VG6Q3 IconNG-moduleiconContainer__SxWZ0";
var _3 = "RatingItem-modulethemed__UiOt1";
export { _1 as "hoverItem", _2 as "icon", _3 as "themed" }
